var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtherna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 167,
    viewBox: "0 0 160 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 86.4,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7475 51.8283C61.5119 51.3559 60.8 51.5235 60.8 52.0514V76.6C60.8 77.1523 61.2477 77.6 61.8 77.6H98.2C98.7523 77.6 99.2 77.1523 99.2 76.6V59.4C99.2 58.8477 98.7523 58.4 98.2 58.4H65.6428C65.2636 58.4 64.9171 58.1855 64.7479 57.8462L61.7475 51.8283ZM103 44C103.552 44 104 44.4477 104 45V77.6C104 80.24 101.84 82.4 99.2 82.4H60.8C58.16 82.4 56 80.24 56 77.6L56.024 48.8C56.024 46.16 58.16 44 60.8 44H62.582C62.9607 44 63.307 44.214 63.4764 44.5528L67.7236 53.0472C67.893 53.386 68.2393 53.6 68.618 53.6H74.391C74.7627 53.6 75.0044 53.2088 74.8382 52.8764L71.1236 45.4472C70.7912 44.7823 71.2747 44 72.018 44H74.582C74.9607 44 75.307 44.214 75.4764 44.5528L79.7236 53.0472C79.893 53.386 80.2393 53.6 80.618 53.6H86.391C86.7627 53.6 87.0044 53.2088 86.8382 52.8764L83.1236 45.4472C82.7912 44.7823 83.2747 44 84.018 44H86.582C86.9607 44 87.307 44.214 87.4764 44.5528L91.7236 53.0472C91.893 53.386 92.2393 53.6 92.618 53.6H98.391C98.7627 53.6 99.0044 53.2088 98.8382 52.8764L95.1236 45.4472C94.7912 44.7823 95.2747 44 96.018 44H103ZM82.6992 69.251C83.2515 69.251 83.6992 68.8033 83.6992 68.251V68.1855C83.6992 67.6333 83.2515 67.1855 82.6992 67.1855H79.6367C79.0844 67.1855 78.6367 66.7378 78.6367 66.1855V65.1357C78.6367 64.5835 79.0844 64.1357 79.6367 64.1357H83.5605C84.1128 64.1357 84.5605 63.688 84.5605 63.1357V63C84.5605 62.4477 84.1128 62 83.5605 62H77C76.4477 62 76 62.4477 76 63V73.7969C76 74.3492 76.4477 74.7969 77 74.7969H83.5781C84.1304 74.7969 84.5781 74.3492 84.5781 73.7969V73.6787C84.5781 73.1264 84.1304 72.6787 83.5781 72.6787H79.6367C79.0844 72.6787 78.6367 72.231 78.6367 71.6787V70.251C78.6367 69.6987 79.0844 69.251 79.6367 69.251H82.6992Z",
    fill: "#A6B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 166.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherna);
export default __webpack_public_path__ + "static/media/Etherna.28e3b86ddf19d407190e0aff3b9a629c.svg";
export { ForwardRef as ReactComponent };